import React from 'react'
import { Avatar as Avt } from '@material-ui/core'
import { GetInitialsName } from '../../../lib/constants'

export const Avatar = ({ thumbnail, name }) => (
  <div className="img-ctn img-xs img-circle">
    {thumbnail ? <img alt="Avatar" src={thumbnail} /> : <Avt>{GetInitialsName(name)}</Avt>}
  </div>
)
